import React from 'react';
import { useSelector } from 'react-redux';
import { FadeInImage } from '../FadeInImage';
import useMenuRedirect from '../../containers/Menu/hooks/useMenuRedirect';

export const ClarovideoLogo = ({
  width = 154,
  height = 30,
  classNames = '',
  redirectOnClick = true,
}) => {
  const { landing_head_logoClarovideo } = useSelector(state => state.asset);
  const { nodes, handleRedirect } = useMenuRedirect();

  return (
    <FadeInImage
      imageSrc={landing_head_logoClarovideo}
      imageAlt={'clarovideo'}
      height={height}
      width={width}
      classNames={[classNames]}
      onClick={
        redirectOnClick ? () => handleRedirect({ node: nodes?.[0] }) : undefined
      }
    />
  );
};
